import HouseMeasures from "./HouseMeasures";

export default HouseMeasures;